/**
 * ResellerRpcClient - AtomRpc integration for the reseller-facing, authenticated
 * dashboard endpoints (`resellers.*`). Used by `/clawinstall/reseller` to resolve
 * the caller's attributed customers + their agents via
 * `resellers.customers.list` (the backend resolves the reseller from
 * `CurrentActor`, never client input). Clerk-authed.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { ResellerRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class ResellerRpcClient extends AtomRpc.Tag<ResellerRpcClient>()(
  "ResellerRpcClient",
  {
    group: ResellerRpcs,
    protocol: makeRpcClientLayer(ResellerRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
